import template from './salesmen.html';
import controller from './salesmen.controller';

let salesmenComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default salesmenComponent;
